import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as reduxFormReducer } from 'redux-form';
import { sponsoredTrialTemplate } from 'modules/sponsoredTrialTemplate/reducer';
import { appConfiguration } from 'modules/appConfiguration/reducer';
import { provider } from 'modules/provider/reducer';
import { backdrop } from 'modules/backdrop/reducer';
import { currentUser } from 'modules/currentUser/reducer';
import { popup } from 'modules/popup/reducer';
import { keyValueStore } from 'modules/keyValueStore/reducer';
import { matches } from 'modules/matches/reducer';
import { intercomReducer } from 'modules/intercom/intercom.reducer';
import { intakeReducer } from 'modules/intake/intake.reducer';
// eslint-disable-next-line import/no-cycle
import {
  authentication,
  profile,
  userGet,
  userCreate,
  userUpdate,
  superUser,
} from 'components/Authentication/reducers';
import { history } from 'functions/history';
import { questionnaire } from 'components/Questionnaire/reducer';
import { chatReducer } from 'chat/reducer';
import { geoLocation } from './geoLocation';
import { serverStatus } from './serverStatus';
import { main } from './main';
import { partner } from './partner';
import { internal } from './internal';

export default combineReducers({
  appConfiguration,
  provider,
  authentication,
  form: reduxFormReducer,
  geo_location: geoLocation,
  main,
  matches,
  questionnaire,
  partner,
  internal,
  profile,
  router: connectRouter(history),
  serverStatus,
  superUser,
  userGet,
  userCreate,
  userUpdate,
  sponsoredTrialTemplate,
  backdrop,
  currentUser,
  popup,
  keyValueStore,
  chat: chatReducer,
  intercom: intercomReducer,
  intake: intakeReducer,
});
